import { USER_AGENT } from 'store/actions/types'

export const setTransportStatus = (payload) => ({
    type: USER_AGENT.CHANGE_TRANSPORT,
    payload
})

export const setUserAgentStatus = (payload) => ({
    type: USER_AGENT.CHANGE_USER_AGENT,
    payload
})

export const setRegisterStatus = (payload) => ({
    type: USER_AGENT.CHANGE_REGISTER_STATUS,
    payload
})

export const setConnectionError = (payload) => ({
    type: USER_AGENT.SET_CONNECTION_ERROR,
    payload
})

export const setReconnectionFailed = (payload) => ({
    type: USER_AGENT.SET_RECONNECTION_FAILED,
    payload
})

export const setCodecCapabilities = (payload) => ({
    type: USER_AGENT.SET_CODEC_CAPABILITIES,
    payload
})
